import AppLogo from "@/components/AppLogo";
import { ButtonSolid } from "@intrasys/core-ui";
import { useNavigate } from "react-router-dom";
import illustration from "@/assets/img/illustrations/undraw_server_down_s-4-lk.svg";
interface Error500Props {
  handleCallback?: () => void;
}

const Error500 = ({ handleCallback }: Error500Props) => {
  const navigate = useNavigate();
  return (
    <div className="grid min-h-screen place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <AppLogo className="mb-10 justify-center" />
      <div className="text-center">
        <p className="text-3xl font-semibold text-primary-600">500</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl">
          Internal server error
        </h1>
        <div className="flex justify-center">
          <img
            src={illustration}
            className="h-60 w-60"
            alt="Internal server error"
          />
        </div>
        <p className="mt-6 text-base leading-7 text-gray-600 dark:text-gray-500">
          Sorry, we had some technical problems during your last operation.
        </p>

        <div className="mt-10 flex items-center justify-center gap-x-6">
          <ButtonSolid
            label="Go back home"
            onClick={() => (handleCallback ? handleCallback() : navigate("/"))}
          />
          <ButtonSolid label="Contact Support" variant={"alternative"} />
        </div>
      </div>
    </div>
  );
};

export default Error500;
